if (!customElements.get('age-verification')) {
  customElements.define(
    'age-verification',
    class AgeVerification extends HTMLElement {
      constructor() {
        super();
        this.storageKey = 'idrinks:age-verified';
      }

      connectedCallback() {
        this.yesBtn = this.querySelector('[data-age-yes]');
        this.noBtn = this.querySelector('[data-age-no]');
        this.declineMessageEl = this.querySelector('[data-age-decline-message]');
        this.contentEl = this.querySelector('[data-age-content]');
        this.declineUrl = this.dataset.declineUrl || '';
        this.expiryDays = parseInt(this.dataset.expiryDays, 10);
        if (isNaN(this.expiryDays)) this.expiryDays = 30;
        this.storage = this.expiryDays === 0 ? sessionStorage : localStorage;
        this.designMode = window.Shopify && Shopify.designMode;
        this.abortController = new AbortController();
        const signal = this.abortController.signal;

        if (this.yesBtn) this.yesBtn.addEventListener('click', this.onAccept.bind(this), { signal });
        if (this.noBtn) this.noBtn.addEventListener('click', this.onDecline.bind(this), { signal });
        document.addEventListener('keydown', this.onKeydown.bind(this), { signal });

        if (!this.designMode && this.isVerified()) {
          document.documentElement.classList.remove('age-verification--locked');
          delete document.documentElement.dataset.ageVerificationPending;
          this.cleanup();
          return;
        }

        this.show();
      }

      cleanup() {
        if (this.abortController) this.abortController.abort();
        this.remove();
      }

      isVerified() {
        const stores = [];
        try { stores.push(localStorage); } catch (e) {}
        try { stores.push(sessionStorage); } catch (e) {}
        for (const store of stores) {
          try {
            const raw = store.getItem(this.storageKey);
            if (!raw) continue;
            const data = JSON.parse(raw);
            if (!data || !data.verified) continue;
            if (data.expires && Date.now() > data.expires) {
              store.removeItem(this.storageKey);
              continue;
            }
            return true;
          } catch (e) {}
        }
        return false;
      }

      setVerified() {
        try {
          const payload = { verified: true };
          if (this.expiryDays > 0) {
            payload.expires = Date.now() + this.expiryDays * 24 * 60 * 60 * 1000;
          }
          this.storage.setItem(this.storageKey, JSON.stringify(payload));
        } catch (e) {}
      }

      show() {
        document.documentElement.classList.add('age-verification--locked');
        requestAnimationFrame(() => this.classList.add('is-open'));
        const focusTarget = this.yesBtn || this.querySelector('button');
        if (focusTarget) focusTarget.focus({ preventScroll: true });
      }

      hide() {
        this.classList.remove('is-open');
        document.documentElement.classList.remove('age-verification--locked');
        delete document.documentElement.dataset.ageVerificationPending;
        setTimeout(() => this.cleanup(), 400);
      }

      onAccept() {
        if (this.designMode) return;
        this.setVerified();
        this.hide();
      }

      onDecline() {
        if (this.designMode) return;
        if (this.declineUrl) {
          window.location.replace(this.declineUrl);
          return;
        }
        if (this.contentEl && this.declineMessageEl) {
          this.contentEl.hidden = true;
          this.declineMessageEl.hidden = false;
        }
      }

      onKeydown(e) {
        if (!this.isConnected) return;
        if (e.key === 'Escape') e.preventDefault();
        if (e.key === 'Tab') {
          const focusable = this.querySelectorAll('button:not([hidden])');
          if (!focusable.length) return;
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      }
    }
  );
}
